import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className, ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const KineticText = ({ lines, delay = 0, className }) => (
    <span className={className} style={{ display: "block" }}>
        {lines.map((line, i) => (
            <span key={i} className="kinetic-mask">
                <motion.span
                    style={{ display: "block", willChange: "transform" }}
                    initial={{ y: "112%" }}
                    animate={{ y: "0%" }}
                    transition={{
                        duration: 1,
                        delay: delay + i * 0.13,
                        ease: [0.22, 1, 0.36, 1],
                    }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export default Reveal;
